(() => {
  const root = document.getElementById('rf-collection-preview');
  if (!root) return;
  const header = document.querySelector('.header.default-header');
  const update = () => root.style.setProperty('--rfcp-header-clearance', window.innerWidth >= 799 && header ? Math.ceil(header.getBoundingClientRect().height + 18) + 'px' : '16px');
  update();
  window.addEventListener('resize', update, { passive: true });
  if (header && 'ResizeObserver' in window) new ResizeObserver(update).observe(header);
  const sort = root.querySelector('#rfcp-sort');
  if (sort) sort.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });
})();
